import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import YouTubePlayer, { YouTubePlayerProps } from 'react-player/youtube';

const StyledYouTubePlayer = styled(YouTubePlayer, {
  shouldForwardProp: (prop) => prop !== 'isResponsive',
})(
  ({
    isResponsive,
  }: {
    isResponsive: YoutubeVideoProps['isResponsive'];
  }) => css`
    margin: 0 auto;
    max-width: 100%;

    ${isResponsive &&
    css`
      position: relative;
      padding-top: 56.25%;

      & > div {
        position: absolute;
        top: 0;
        left: 0;
      }
    `}
  `,
);

const YoutubeVideo = ({
  youtubeVideoId,
  isResponsive,
  ...rest
}: YoutubeVideoProps) => (
  <StyledYouTubePlayer
    url={`https://www.youtube-nocookie.com/watch?v=${youtubeVideoId}`}
    controls={true}
    isResponsive={isResponsive}
    width={isResponsive ? '100%' : '640px'}
    height={isResponsive ? '0' : '360px'}
    {...rest}
  />
);

export interface YoutubeVideoProps extends YouTubePlayerProps {
  youtubeVideoId: string;
  isResponsive?: boolean;
}

export default YoutubeVideo;
